module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/~/babel-runtime/core-js/object/create.js
// module id = 1246
// module chunks = 3